/**
 * RC_order_info_for_pay
 */

const hasChinese = function(str) {
  if(!str) {
    return false
  }

  var reg = /[\u4e00-\u9fa5]/
  return reg.test(str)
}

const RC_order_info_for_pay = function(input) {
  budo_log.debug("#15 RC_order_info_for_pay", input)

  if(!input) {
    return input;
  }

  if(hasChinese(input.orderType)) {
    input.orderType = "AUTO"
  }

  return input
}

export {
  RC_order_info_for_pay
}